// api
import { useGetMeQuery } from 'redux-store/api/auth';
import { IProfileRole } from 'redux-store/api/profiles';
// custom hooks
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
// selectors
import { authSelector } from 'redux-store/selector';

export const useUserInfo = () => {
  const { companyId, isAuth } = useAppSelector(authSelector);

  const { data: userMe } = useGetMeQuery(undefined, {
    skip: !isAuth,
  });

  const getProfileCurrentRole = (roles: IProfileRole[]) =>
    roles.find(({ companyId: id }) => companyId === id.toString());

  const currentRole =
    userMe?.roles?.length && companyId
      ? userMe.roles.find(({ companyId: id }) => companyId === id.toString())
      : null;

  const isOwner = currentRole?.isOwner ? currentRole.isOwner : null;

  return {
    currentRole,
    isOwner,
    getProfileCurrentRole,
  };
};
